import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import MaintennanceDropDownFilter from "../../../../components/FilterBox/MaintenanceFilter/MaintennanceDropDownFilter";
import MaintenanceTable from "../../../../components/Tables/MaintenanceTable";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { format } from "date-fns";

import {
  InwardItemWiseSumm,
  InwardItemWiseSummFun,
  StoreFilters,
} from "../../../../Redux/Slice/Maintenance/MaintenanceSlice";
import { Loader } from "../../../../components/Loader/Loader";
import { FiMenu } from "react-icons/fi";
import MaintenanceFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintenanceFilter";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { useTheme } from "../../../../Themecontext/Themecontext";
import MaintenanceCelender from "../../../../components/Calendar/MaintenanceCelender";
import Calendar from "react-calendar";

export const InwardItemWise = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StoreFiltersdata, InwardItemWiseSummdata } = useSelector(
    (state) => state.MaintenanceSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTORE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTOREDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const [bookNameIds, setBookNameIds] = useState([]);
  const [itemGroupIds, setItemGroupIds] = useState([]);
  const [itemNameIds, setItemNameIds] = useState([]);

  const [bookNameSearch, setBookNameSearch] = useState("");
  const [itemGroupSearch, setItemGroupSearch] = useState("");
  const [itemNameSearch, setItemNameSearch] = useState("");

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };
  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  console.log(safeFormat(startDate));
  console.log(endDate);

  useEffect(() => {
    if (!startDate || !endDate) return;

    // setLoading(true);

    dispatch(StoreFilters());

    dispatch(
      InwardItemWiseSumm({
        firm: Firm,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );
  }, [dispatch,startDate, endDate,Firm]);

  const [filter, setFilter] = useState({
    bookName: [],
    itemGroup: [],
    itemName: [],
  });

  const [search, setSearch] = useState({
    bookName: "",
    itemGroup: "",
    itemName: "",
  });

  const bookNameList =
    StoreFiltersdata?.Inwardbook?.map((item) => ({
      label: item.TransactionName,
      value: item.TransactionTypeID,
    })) || [];

  const itemGroupList =
    StoreFiltersdata?.ItemGroup?.map((item) => ({
      label: item.ItemGroupName,
      value: item.ItemGroupID,
    })) || [];

  const itemList =
    StoreFiltersdata?.Inwarditem?.map((item) => ({
      label: item.itemname,
      value: item.itemid,
    })) || [];

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const columns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name ",
      key: "itemname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Unit Name",
      key: "unitname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Qty", key: "Qty", align: "right", format: true },
    { label: "Rate", key: "rate", align: "right", format: true },
    { label: "Amount", key: "Amount", align: "right", format: true },
  ];

  const data = (InwardItemWiseSummdata?.Data || []).map((row) => ({
    itemname: row.itemname,
    unitname: row.unitname || "",
    Qty: row.Qty || 0,
    rate: row.rate || 0,
    Amount: row.Amount || 0,
  }));

  const handleSubmit = () => {
    dispatch(InwardItemWiseSummFun());

    dispatch(
      InwardItemWiseSumm({
        firm: Firm,
        StartDate: format(startDate, "yyyy-MM-dd"),
        EndDate: format(endDate, "yyyy-MM-dd"),
        BookIDs: filter.bookName.toString(),
        ItemGrpIDs: filter.itemGroup.toString(),
        ItemIDs: filter.itemName.toString(),
      }),
    );
  };


  const handleSubmit1 = () => {
    dispatch(InwardItemWiseSummFun());

    dispatch(
      InwardItemWiseSumm({
        firm: Firm,
        StartDate: format(startDate, "yyyy-MM-dd"),
        EndDate: format(endDate, "yyyy-MM-dd"),
        BookIDs: bookNameIds.toString(),
        ItemGrpIDs: itemGroupIds.toString(),
        ItemIDs: itemNameIds.toString(),
      }),
    );
  };




  if (!StoreFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!InwardItemWiseSummdata || InwardItemWiseSummdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        minHeight: "100vh",
      }}
    >
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{
            color: isdark === "light" ? "#000" : "#FFF",
          }}
        >
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#FFF",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>
            <MaintenanceFilterBox
              title="Book Name"
              items={bookNameList}
              search={search.bookName}
              setSearch={(val) => handleSearch("bookName", val)}
              selectedItems={filter.bookName}
              toggleItem={(item) => toggleItem("bookName", item)}
              selectAll={() => selectAll("bookName", bookNameList)}
            />

            <MaintenanceFilterBox
              title="Item Group"
              items={itemGroupList}
              search={search.itemGroup}
              setSearch={(val) => handleSearch("itemGroup", val)}
              selectedItems={filter.itemGroup}
              toggleItem={(item) => toggleItem("itemGroup", item)}
              selectAll={() => selectAll("itemGroup", itemGroupList)}
            />

            <MaintenanceFilterBox
              title="Item Name"
              items={itemList}
              search={search.itemName}
              setSearch={(val) => handleSearch("itemName", val)}
              selectedItems={filter.itemName}
              toggleItem={(item) => toggleItem("itemName", item)}
              selectAll={() => selectAll("itemName", itemList)}
            />

            <button
              onClick={handleSubmit}
              style={{
                width: "100%",
                // height: "45px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color: "#fff",
                fontWeight: "700",
                padding: "12px",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {/* 🔷 FILTER BOX */}
      <div
        className="d-none d-lg-block"
        style={{
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
          marginBottom: "20px",
        }}
      >
        <Row className="align-items-end g-2">
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <div>
              <h3
                style={{
                  color: isdark === "light" ? iscolour?.Colour11 : "#fff",
                  fontWeight: "700",
                  fontSize: "13px",
                  marginBottom: "5px",
                }}
              >
                Date Range
              </h3>
            </div>
            <div>
              <div
                onClick={() => setShowDatePicker(true)}
                className="date"
                style={{
                  padding: " 12px 20px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  textAlign: "center",
                  border: `1px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7}`,
                  color: isdark === "light" ? "#000" : "#fff",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </Col>
          {/* Book Name */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintennanceDropDownFilter
              label="Book Name"
              data={bookNameList}
              selectedValue={bookNameSearch}
              setSelectedValue={setBookNameSearch}
              selectedId={bookNameIds}
              setSelectedId={setBookNameIds}
              placeholder="Select Book"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Party Name */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintennanceDropDownFilter
              label="Item Group"
              data={itemGroupList}
              selectedValue={itemGroupSearch}
              setSelectedValue={setItemGroupSearch}
              selectedId={itemGroupIds}
              setSelectedId={setItemGroupIds}
              placeholder="Select Item Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Item Name */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintennanceDropDownFilter
              label="Item Name"
              data={itemList}
              selectedValue={itemNameSearch}
              setSelectedValue={setItemNameSearch}
              selectedId={itemNameIds}
              setSelectedId={setItemNameIds}
              placeholder="Select Item"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Button */}
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="mt-3 hover-scale-btn "
          >
            <button
              onClick={handleSubmit1}
              style={{
                width: "100%",
                // height: "45px",
                padding: "12px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color: "#fff",
                fontWeight: "700",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      {/* 🔷 TABLE */}
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          INWARD ITEMWISE
        </div>

        <MaintenanceTable columns={columns} data={data} />
      </div>
      {/* 🔷 DATE PICKER MODAL */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <MaintenanceCelender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
